const frameworks = Object.freeze({
    MVC:1,
    VUE:2
});

export default frameworks;